import * as firebaseApp from 'firebase/app'
import { coworkingsConstants } from '../redux-constants'
import { singleWorkstationsFetch } from '../actions/singleWorkstations.actions'
import { meetingRoomsFetch } from '../actions/meetingRooms.actions'
import { isEmpty, max } from 'lodash'

export function getNear(id, lat, lng, maxResults) {
    return async (
        dispatch,
        getState,
        { firebase, firestore, geoFirestore }
    ) => {
        try {
            const geocollection = geoFirestore.collection('coworkings')
            const query = geocollection.near({
                center: new firebaseApp.firestore.GeoPoint(lat, lng),
                radius: 30,
            })

            let nearCoworkings = []

            const results = await query.limit(maxResults).get()
            if (results?.docs.length > 0) {
                results.docs.forEach(item => {
                    if (item.id !== id)
                        nearCoworkings.push({ id: item.id, ...item.data() })
                })

                dispatch(ajaxCallSuccess(nearCoworkings))
            } else {
                dispatch(ajaxCallFailure('Not found near coworkings'))
            }
        } catch (error) {
            dispatch(ajaxCallFailure(error))
        }
    }
}

export function loadCoworkings(params = {}) {
    return (dispatch, getState, { firestore, firebase, geoFirestore }) => {
        console.log('pass here', params)

        const coworkingIdFlag = typeof params === 'string'

        dispatch(
            loadingCoworkingsProgress(
                coworkingIdFlag
                    ? {
                          ...JSON.parse(
                              window.sessionStorage.getItem('sessionFilter')
                          ),
                      }
                    : {
                          ...JSON.parse(
                              window.sessionStorage.getItem('sessionFilter')
                          ),
                          ...params,
                      }
            )
        )

        let filters = getState().coworking.activeFilters

        let coworkingRef = geoFirestore.collection('coworkings')

        // coworkingRef = coworkingRef.where('city', '==', 'Brescia')

        // console.log('FILTERS ==>', filters)
        // console.log('COWORKING ID FLAG ==>', !isEmpty(filters), coworkingIdFlag)

        if (!isEmpty(filters) && !coworkingIdFlag) {
            Object.keys(filters)
                .filter(
                    el =>
                        Object.keys(filters[el]).length ||
                        (filters[el].length &&
                            (typeof filters[el] === 'string' ||
                                Array.isArray(filters[el])))
                )
                .forEach(key => {
                    switch (key) {
                        default:
                            // console.log('TESTING', key)
                            if (typeof filters[key] === 'string')
                                coworkingRef = coworkingRef.where(
                                    key,
                                    '==',
                                    filters[key]
                                )
                            break
                        case 'quantity':
                            // console.log('TESTING', key)
                            coworkingRef = coworkingRef.where(
                                key,
                                '>=',
                                filters[key]
                            )
                            break
                        case 'price':
                            // console.log('TESTING', key)
                            // console.log(
                            //     'PRICE ==>',
                            //     key,
                            //     filters.price[0],
                            //     filters.price[1]
                            // )
                            // coworkingRef = coworkingRef
                            //     .where(
                            //         'singleWorkstationPrice',
                            //         '>=',
                            //         filters.price[0]
                            //     )
                            //     .where(
                            //         'singleWorkstationPrice',
                            //         '<=',
                            //         filters.price[1]
                            //     )
                            break
                        case 'service':
                        case 'nearbyPlace':
                            Object.keys(filters[key])
                                .filter(el => filters[key][el])
                                .forEach(subkey => {
                                    // console.log('TESTING', key, subkey)
                                    coworkingRef = coworkingRef.where(
                                        `${key}s.${subkey}`,
                                        '==',
                                        true
                                    )
                                })
                            break
                        case 'professions':
                            coworkingRef = coworkingRef.where(
                                'professions',
                                'array-contains-any',
                                Object.keys(filters[key]).filter(
                                    fil => filters[key][fil]
                                )
                            )
                            break
                        case 'startTime':
                            // console.log('TESTING', key)
                            filters.endTime
                                ? (coworkingRef = coworkingRef
                                      .where(
                                          'startTime',
                                          '>=',
                                          filters.startTime
                                      )
                                      .where('endTime', '<=', filters.endTime))
                                : (coworkingRef = coworkingRef.where(
                                      'startTime',
                                      '>=',
                                      filters.startTime
                                  ))
                            break
                    }
                })
        }

        coworkingRef
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach(async doc => {
                    const data = doc.data()
                    const id = doc.id

                    let flag = true

                    if (!coworkingIdFlag) {
                        if (filters.type)
                            if (
                                filters.types
                                    ? filters.types['single_desk']
                                    : false
                            ) {
                                let sw = await geoFirestore
                                    .collection('coworkings')
                                    .doc(id)
                                    .collection('singleWorkstations')
                                    .get()
                                // .then(response => {
                                //     response.forEach(document => {
                                //         flag =
                                //             flag &&
                                //             document.data().quantity >=
                                //                 filters.quantity
                                //     })
                                // })
                                // .catch(error => {
                                //     console.log('ERROR ==>', error)
                                // })
                                flag = flag && sw.size
                            }
                        if (
                            filters.types
                                ? filters.types['meeting_room']
                                : false
                        ) {
                            await geoFirestore
                                .collection('coworkings')
                                .doc(id)
                                .collection('meetingRooms')
                                .get()
                                .then(response => {
                                    let maxQuantity
                                    response.forEach(document => {
                                        maxQuantity = max(
                                            maxQuantity,
                                            document.data().quantity
                                        )
                                    })
                                    flag =
                                        flag && maxQuantity >= filters.quantity
                                })
                                .catch(error => {
                                    console.log('ERROR ==>', error)
                                })
                        }
                    } else {
                        flag = flag && id === params
                    }

                    if (flag)
                        dispatch(
                            updateCoworkings({
                                id,
                                ...data,
                                services: Object.keys(data.services).filter(
                                    el => data.services[el]
                                ),
                                nearbyPlaces: Object.keys(
                                    data.nearbyPlaces
                                ).filter(el => data.nearbyPlaces[el]),
                            })
                        )
                })

                //Dispatch All
                dispatch(loadingCoworkingsSuccess())
            })
            .catch(error => {
                dispatch(loadingCoworkingsError(error.message))
            })
    }
}

export function updateCoworking(id, payload, coordinates) {
    return (dispatch, getState, { firebase, firestore }) => {
        dispatch(ajaxCallProgress())

        const field = firestore.collection('/coworkings').doc(id)
        field
            .update({
                ...payload,
                coordinates: new firebaseApp.firestore.GeoPoint(...coordinates),
            })
            .then(res => {
                dispatch(ajaxCallSuccess())
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function updateComposition(id, payload) {
    return async (dispatch, getState, { firebase, firestore }) => {
        const coworking = firestore.collection('coworkings').doc(id)

        try {
            await coworking.update({
                singleWorkstationPrice: payload.dailyCost,
            })

            dispatch(ajaxCallSuccess())

            const singleWorkstations = coworking.collection(
                'singleWorkstations'
            )
            let singleWorkstationsCount = await singleWorkstations.get()
            singleWorkstationsCount = singleWorkstationsCount.size

            if (payload.availability > singleWorkstationsCount) {
                let diff = payload.availability - singleWorkstationsCount
                singleWorkstations.get().then(docs => {
                    let i = 0
                    for (i; i < diff; i++) {
                        singleWorkstations.add({})
                    }
                })
            } else if (payload.availability < singleWorkstationsCount) {
                let diff = singleWorkstationsCount - payload.availability
                singleWorkstations.get().then(docs => {
                    let i = 0
                    for (i; i < diff; i++) {
                        singleWorkstations
                            .doc(docs.docs[i].id)
                            .delete()
                            .then(() => {
                                console.log('Deleted workstation')
                            })
                    }
                })
            }

            dispatch(singleWorkstationsFetch())

            const meetingRooms = coworking.collection('meetingRooms')

            let meetingRoomsIds = []
            payload.meetingRooms.forEach(meetingRoom => {
                meetingRoomsIds.push(meetingRoom.id)
            })

            meetingRooms.get().then(docs => {
                docs.forEach(doc => {
                    if (!meetingRoomsIds.includes(doc.id)) {
                        meetingRooms
                            .doc(doc.id)
                            .delete()
                            .then(() => {
                                console.log('Deleted one meeting room')
                            })
                    }
                })
            })

            payload.meetingRooms.forEach(meetingRoom => {
                if (meetingRoom.id) {
                    console.log('Meeting Room Id', meetingRoom)
                    meetingRooms.doc(meetingRoom.id).set({
                        name: meetingRoom.name,
                        priceHour: meetingRoom.priceHour,
                        quantity: meetingRoom.quantity,
                    })
                } else {
                    console.log('Meeting Room', meetingRoom)
                    meetingRooms.add({
                        name: meetingRoom.name,
                        priceHour: meetingRoom.priceHour,
                        quantity: meetingRoom.quantity,
                    })
                }
            })

            dispatch(meetingRoomsFetch())
        } catch (error) {
            console.log('Error', error)
            dispatch(ajaxCallFailure(error.code))
        }
    }
}

export function addCoworking(cowoId, payload, coordinates, userId) {
    return (dispatch, getState, { firebase, firestore, geoFirestore }) => {
        dispatch(ajaxCallProgress())

        const geocollection = geoFirestore.collection('coworkings').doc(cowoId)
        let data = {
            ...payload,
            coordinates: new firebaseApp.firestore.GeoPoint(...coordinates),
        }
        geocollection
            .set(data)
            .then(() => {
                firestore
                    .collection('users')
                    .doc(userId)
                    .update({
                        ownerOf: new firebaseApp.firestore.FieldValue.arrayUnion(
                            cowoId
                        ),
                    })
                    .then(res => {
                        dispatch({
                            type: '[Coworkings] Fetch',
                            payload: [{ id: cowoId, ...data }],
                        })
                    })
                    .catch(error => {
                        console.log(error)
                        dispatch(ajaxCallFailure(error.code))
                    })
            })
            .catch(error => {
                console.log(error)
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

function loadingCoworkingsProgress(payload) {
    return {
        type: coworkingsConstants.LOADING_COWORKINGS_REQUEST,
        payload,
    }
}

function loadingCoworkingsSuccess() {
    return {
        type: coworkingsConstants.LOADING_COWORKINGS_DONE,
    }
}

function updateCoworkings(payload) {
    return {
        type: coworkingsConstants.UPDATE_COWORKINGS,
        payload,
    }
}

function loadingCoworkingsError(payload) {
    return {
        type: coworkingsConstants.LOADING_COWORKINGS_FAILURE,
        payload,
    }
}

export function ajaxCallProgress() {
    return {
        type: coworkingsConstants.AJAX_CALL_REQUEST,
    }
}

export function ajaxCallSuccess(payload) {
    return {
        type: coworkingsConstants.AJAX_CALL_SUCCESS,
        payload,
    }
}

function ajaxCallFailure(payload) {
    return {
        type: coworkingsConstants.AJAX_CALL_FAILURE,
        payload,
    }
}
